module.exports = __webpack_public_path__ + "img/setting-2.229544f5.svg";